import React                  from 'react';
import classnames             from 'classnames';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';

import {
  getPartPurchaseStatus,
  getPartStatus,
}from 'pu-utils/PartsUtilities';    

const PartActionSelector = (props) => {
  var status = getPartStatus(props.status, props.selected_quantity)
  var purchase_status = getPartPurchaseStatus(props.purchase_status, props.selected_quantity)

  const allowed_buy = ["enough-stock", "substitute", "other"];
  
  return (
    <select 
     className="form-control form-control-sm offer-action" 
     onChange={e => props.onChangePartAction(props.offer_id, e.target.value, props.selected_quantity)} 
     defaultValue={purchase_status} >
      <option value="">Select Action</option>
      {(allowed_buy.includes(status))
        ? <option value="buy">Buy</option>
        : null
      }
      <option value="i-will-provide">I will provide</option>
      <option value="no-install">Do not install</option>
    </select>
  )
}
export default PartActionSelector;